import { render, staticRenderFns } from "./ViewTeachBackModal.vue?vue&type=template&id=87f9b3b4&scoped=true"
import script from "./ViewTeachBackModal.vue?vue&type=script&lang=js"
export * from "./ViewTeachBackModal.vue?vue&type=script&lang=js"
import style0 from "./ViewTeachBackModal.vue?vue&type=style&index=0&id=87f9b3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f9b3b4",
  null
  
)

export default component.exports